import { render, staticRenderFns } from "./NewsContainer.vue?vue&type=template&id=7f7d3cb2&scoped=true&"
import script from "./NewsContainer.vue?vue&type=script&lang=js&"
export * from "./NewsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NewsContainer.vue?vue&type=style&index=0&id=7f7d3cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d3cb2",
  null
  
)

export default component.exports